export default "__VITE_ASSET__DVl_DWhX__"